"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const a11y_helpers_1 = require("../../styles/a11y_helpers");
const styled_1 = __importDefault(require("../../styles/styled"));
const theme_1 = __importDefault(require("../../styles/theme"));
const Ring = styled_1.default.div({
    display: 'inline-block',
    position: 'relative',
}, ({ size }) => {
    return {
        width: size,
        height: size,
    };
});
const Item = styled_1.default.div({
    boxSizing: 'border-box',
    display: 'block',
    position: 'absolute',
    borderRadius: '50%',
    animation: `${theme_1.default.keyframes.rotate} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite`,
}, ({ delay, size, color }) => {
    return {
        border: `6px solid ${color}`,
        borderColor: `${color} transparent transparent transparent`,
        animationDelay: delay,
        width: size,
        height: size,
    };
});
const Spinner = ({ color, size }) => {
    return ((0, jsx_runtime_1.jsxs)(Ring, Object.assign({ size: size, role: "status", "aria-busy": "true", "aria-live": "polite", "data-testid": "spinner-animation" }, { children: [(0, jsx_runtime_1.jsx)(a11y_helpers_1.ScreenReaderOnly, { children: "Loading" }), (0, jsx_runtime_1.jsx)(Item, { delay: "0s", color: color, size: size }), (0, jsx_runtime_1.jsx)(Item, { delay: "-0.45s", color: color, size: size }), (0, jsx_runtime_1.jsx)(Item, { delay: "-0.3s", color: color, size: size }), (0, jsx_runtime_1.jsx)(Item, { delay: "-0.15s", color: color, size: size })] })));
};
exports.Spinner = Spinner;
exports.Spinner.defaultProps = {
    color: theme_1.default.colors.azure,
    size: '51px',
};
//# sourceMappingURL=spinner.js.map